export default __webpack_public_path__ + "static/media/card-5.0bf08e22.png";